import { Card, CardBody, Col } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { AnimatedAvatarTitle } from "../../../Constants/Constants";
import { AnimatedAvatarSubTitle, AnimatedAvatarData } from "../../../Data/UiKits/Avatars";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const AnimatedAvatar = () => {
  return (
    <Col xl="4" md="6">
      <Card className="height-equal">
        <CommonCardHeader title={AnimatedAvatarTitle} span={AnimatedAvatarSubTitle}/>
        <CardBody className="avatar-showcase">
          <div className="avatars">
            {AnimatedAvatarData.map((item, index) => (
              <div className="avatar" key={index}>
                <Image className={`${item.imageClass} rounded-circle`} src={dynamicImage(item.image)} alt="#" />
                <div className={`status animation-ping bg-${item.color}`}>
                </div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AnimatedAvatar;
